/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Text from '../../atomic/Text'
import styles from './Title.module.css'

const Title = ({ title }: { title: string }) => {
  const { colorSubheader: color } = useHeaderContext()

  return (
    <Text
      text={title}
      className={styles.title}
      style={{ color: color ? `var(${color})` : 'var(--color-black)' }}
    />
  )
}

export default Title
